import React, { Component } from 'react';
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { sessionExpireMessage, toastError, toastSuccess, tokenInavlidMessage } from '../../../utils/constants'
import Header from '../../../common_components/Header';
import Loader from '../../../utils/Loader';
import { get_master_details_action, insert_update_master_action, } from '../../../actions/adminAction/master_action';

class masterDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            navType: '', tabSelected: '',
            ID: '',
            NameErr: '',
            Name: '',
            FullAccessM: false, ReadAccessM: false, WriteAccessM: false, UpdateAccessM: false, DeleteAccessM: false, DownloadAccessM: false, Is_SpecialAccessM: false, SendAccessM: false,
            FullAccessB: false, ReadAccessB: false, WriteAccessB: false, UpdateAccessB: false, DeleteAccessB: false, DownloadAccessB: false, Is_SpecialAccessB: false, SendAccessB: false,
            FullAccessO: false, ReadAccessO: false, WriteAccessO: false, UpdateAccessO: false, DeleteAccessO: false, DownloadAccessO: false, Is_SpecialAccessO: false, SendAccessO: false,
            FullAccessE: false, ReadAccessE: false, WriteAccessE: false, UpdateAccessE: false, DeleteAccessE: false, DownloadAccessE: false, Is_SpecialAccessE: false, SendAccessE: false,
            FullAccessS: false, ReadAccessS: false, WriteAccessS: false, UpdateAccessS: false, DeleteAccessS: false, DownloadAccessS: false, Is_SpecialAccessS: false, SendAccessS: false,
        }
    }

    componentDidMount() {
        const loginData = JSON.parse(sessionStorage.getItem("loginDataSS"));
        if (!loginData) {
            setTimeout(() => this.props.navigate('/'), 200);
            return;
        }

        window.scrollTo(0, 0);
        const { navType, tabSelected, ID } = this.props.location?.state || {};
        const loginAccessList = JSON.parse(sessionStorage.getItem('loginAccesslist')) || [];

        // Check Master Module Access
        const masterListModule = loginAccessList.find(module => module.ModuleName === "Master");
        if (!masterListModule || (!masterListModule.FullAccess && !masterListModule.ReadAccess)) {
            this.props.navigate('/login');
            return;
        }

        // Helper function to set access permissions
        const setPermissions = (module, prefix) => {
            if (!module) return {};
            const permissions = {
                [`FullAccess${prefix}`]: !!module.FullAccess,
                [`ReadAccess${prefix}`]: !!module.ReadAccess || !!module.FullAccess,
                [`WriteAccess${prefix}`]: !!module.WriteAccess || !!module.FullAccess,
                [`UpdateAccess${prefix}`]: !!module.UpdateAccess || !!module.FullAccess,
                [`DeleteAccess${prefix}`]: !!module.DeleteAccess || !!module.FullAccess,
                [`DownloadAccess${prefix}`]: !!module.DownloadAccess || !!module.FullAccess,
                [`Is_SpecialAccess${prefix}`]: !!module.Is_SpecialAccess || !!module.FullAccess,
                [`SendAccess${prefix}`]: !!module.SendAccess || !!module.FullAccess,
            };
            return permissions;
        };

        // Set access permissions for each module
        this.setState({
            ...setPermissions(masterListModule, 'M'),
            ...setPermissions(loginAccessList.find(module => module.ModuleName === "Business Sector"), 'B'),
            ...setPermissions(loginAccessList.find(module => module.ModuleName === "Organization Type"), 'O'),
            ...setPermissions(loginAccessList.find(module => module.ModuleName === "Enterprise Type"), 'E'),
            ...setPermissions(loginAccessList.find(module => module.ModuleName === "Service Type"), 'S'),
            navType, tabSelected, ID,
        }, () => {
            setTimeout(() => {
                this.setState({ loading: false }, () => {
                    if (ID) this.getMasterDetails(ID);
                });
            }, 2000);
        });
    }

    getMasterDetails(ID) {
        const { tabSelected } = this.state;
        this.setState({ isLoading: true });
        this.props.get_master_details_action(ID, tabSelected)
            .then((data) => {
                console.log(data);
                if (data.error !== 1) {
                    const masterData = data.data?.[0];
                    this.setState({
                        ID: tabSelected == 'B' ? masterData.BusinessSectorID : tabSelected == 'O' ? masterData.OrganizationTypeID :
                            tabSelected == 'E' ? masterData.EnterpriseTypeID : tabSelected == 'S' ? masterData.PrimaryServicesID : null,
                        Name: masterData.Name,
                    });
                    this.setState({ isLoading: false });
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false });
                    toastError(data?.data?.ErrorMsg);
                }
            });
    }

    insertUpdateMaster() {
        const { ID, Name, tabSelected } = this.state
        this.inputValidation().then(res => {
            if (!res) {
                this.setState({ isLoading: true })
                this.props
                    .insert_update_master_action(ID, Name, tabSelected)
                    .then((data) => {
                        if (data.error != 1) {
                            if (data.data.ErrorMsg == null) {
                                this.setState({ isLoading: false }, () => toastSuccess('Submitted Successfully'))
                                setTimeout(() => {
                                    this.props.navigate('/master_list')
                                }, 500);
                            } else {
                                if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                                    //after session expire.....................
                                    sessionStorage.clear();
                                    this.props.navigate("/");
                                    setTimeout(() => {
                                        toastError(data.msg);
                                    }, 2000);
                                } else {
                                    toastError(data.data);
                                }
                                this.setState({ isLoading: false })
                                toastError(data.data.ErrorMsg);
                            }
                        } else {
                            this.setState({ isLoading: false })
                            toastError(data.msg);
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                toastError("Please enter mandatory fields")
            }
        })
    }
    inputValidation() {
        const { ID, Name } = this.state
        var Err = false
        return new Promise((resolve) => {
            if (!ID) {
                if (Name == '' || Name == null) {
                    Err = true
                    this.setState({ NameErr: 'Please enter Name' })
                }
            }
            resolve(Err)
        })
    }


    navigateBackMasterList() {
        this.props.navigate('/master_list')
    }
    render() {
        const { isLoading, ID, tabSelected, Name, NameErr, navType,
            FullAccessM, ReadAccessM, WriteAccessM, UpdateAccessM, DeleteAccessM, DownloadAccessM, Is_SpecialAccessM, SendAccessM,
            FullAccessB, ReadAccessB, WriteAccessB, UpdateAccessB, DeleteAccessB, DownloadAccessB, Is_SpecialAccessB, SendAccessB,
            FullAccessO, ReadAccessO, WriteAccessO, UpdateAccessO, DeleteAccessO, DownloadAccessO, Is_SpecialAccessO, SendAccessO,
            FullAccessE, ReadAccessE, WriteAccessE, UpdateAccessE, DeleteAccessE, DownloadAccessE, Is_SpecialAccessE, SendAccessE,
            FullAccessS, ReadAccessS, WriteAccessS, UpdateAccessS, DeleteAccessS, DownloadAccessS, Is_SpecialAccessS, SendAccessS,
        } = this.state
        if (isLoading) {
            return <Loader></Loader>;
        }
        return (
            <>

                <Header />
                <ToastContainer />
                {console.log(FullAccessB, 'FullAccessB')}
                <section class="registration_form">
                    <div class="container">
                        <h6 className='pt-2'>Master Details</h6>
                        <div class="row mt-15">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="custom_tabs" id="mytabs">
                                            <div class="tab-content">
                                                <div class="tab-pane active" id="Company_Profile_tab" role="tabpanel" aria-labelledby="Company_Profile_tab" tabindex="0">
                                                    {ReadAccessM && <>
                                                        {((tabSelected == 'B' && ReadAccessB) || (tabSelected == 'E' && ReadAccessE) || (tabSelected == 'O' && ReadAccessO) || (tabSelected == 'S' && ReadAccessS)) && (
                                                            <fieldset>
                                                                <legend className='mb-0 pb-0'>{tabSelected == 'B' ? 'Business Sector' : tabSelected == 'O' ? 'Organization Type' : tabSelected == 'E' ? 'Enterprise Type' : tabSelected == 'S' ? 'Service Type' : ''}</legend>
                                                                <div class="row">
                                                                    <div class="col-md-12">
                                                                        <div class="row mb-3">
                                                                            <div class="col-md-3">
                                                                                <div class="form-group">
                                                                                    <label>Name<span className="red-star text-danger">*</span></label>
                                                                                    <input type="text" disabled={navType == 1} class="form-control" placeholder="Enter Name" value={Name}
                                                                                        onChange={(e) => { this.setState({ Name: e.target.value, NameErr: '' }) }} />
                                                                                    {<span className='text-danger text-start text-left d-block  ml-2'>{NameErr}</span>}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </fieldset>)}
                                                    </>}
                                                    <div class="row">
                                                        <div class="col-md-12 text-right">
                                                            <button class="btn btn-primary next_btn mx-2"
                                                                onClick={() => this.navigateBackMasterList()}
                                                            >
                                                                Back
                                                            </button>
                                                            {ID ? <>
                                                                {((tabSelected == 'B' && UpdateAccessB) || (tabSelected == 'E' && UpdateAccessE) || (tabSelected == 'O' && UpdateAccessO) || (tabSelected == 'S' && UpdateAccessS)) && (
                                                                    <button class="btn btn-primary next_btn"
                                                                        onClick={() => this.insertUpdateMaster()}
                                                                    >
                                                                        Submit
                                                                    </button>
                                                                )}
                                                            </> : <>
                                                                {((tabSelected == 'B' && WriteAccessB) || (tabSelected == 'E' && WriteAccessE) || (tabSelected == 'O' && WriteAccessO) || (tabSelected == 'S' && WriteAccessS)) && (
                                                                    <button class="btn btn-primary next_btn"
                                                                        onClick={() => this.insertUpdateMaster()}
                                                                    >
                                                                        Submit
                                                                    </button>
                                                                )}
                                                            </>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </section >
            </>
        )
    }
}

export default withRouter(connect(null, { get_master_details_action, insert_update_master_action, })(masterDetail));
